const fields = [
  {
    dataFieldName: 'id' as 'id',
    name: 'ID',
    width: '5%',
  },
  {
    dataFieldName: 'competition' as 'competition',
    name: 'Название соревнования',
    width: '10%',
  },
  {
    dataFieldName: 'place' as 'place',
    name: 'Место',
    width: '5%',
  },
  {
    dataFieldName: 'dateChosen' as 'dateChosen',
    name: 'Выбор награды',
    width: '20%',
  },
  {
    dataFieldName: 'dateHasGot' as 'dateHasGot',
    name: 'Получение награды',
    width: '15%',
  },
  {
    dataFieldName: 'status' as 'status',
    name: 'Статус',
    width: '10%',
  },
  {
    dataFieldName: 'awardChosen' as 'awardChosen',
    name: 'Выбранная награда',
    width: '15%',
  },
];

export { fields };
